import Modal from '../ui/Modal';
import { useTranslation } from '@/i18n';

interface PartnershipRequestModalProps {
  closeModal: () => void;
  onConfirm: () => void;
  multiple?: boolean;
}

const PartnershipRequestModal = ({
  closeModal,
  onConfirm,
  multiple = false,
}: PartnershipRequestModalProps) => {
  const { t } = useTranslation();
  const message = t('receivers.modals.partnershipRequest.message', {
    multiple: multiple ? 'des' : 'une',
    plural: multiple ? 's' : '',
  });

  return (
    <Modal
      title={t('receivers.modals.partnershipRequest.title')}
      actionTitle={t('receivers.modals.partnershipRequest.actionTitle')}
      closeModal={closeModal}
      message={message}
      actionOnClick={onConfirm}
    />
  );
};

export default PartnershipRequestModal;
